const ShipOwnerMenu = (props: any) => (
    <svg
        width={24}
        height={25}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2 20.3233C2.22717 20.6398 2.52797 20.8962 2.87642 21.0704C3.22488 21.2447 3.6105 21.3314 4 21.3233C4.3895 21.3314 4.77512 21.2447 5.12358 21.0704C5.47203 20.8962 5.77283 20.6398 6 20.3233C6.22717 20.0068 6.52797 19.7504 6.87642 19.5761C7.22488 19.4019 7.6105 19.3151 8 19.3233C8.3895 19.3151 8.77512 19.4019 9.12358 19.5761C9.47203 19.7504 9.77283 20.0068 10 20.3233C10.2272 20.6398 10.528 20.8962 10.8764 21.0704C11.2249 21.2447 11.6105 21.3314 12 21.3233C12.3895 21.3314 12.7751 21.2447 13.1236 21.0704C13.472 20.8962 13.7728 20.6398 14 20.3233C14.2272 20.0068 14.528 19.7504 14.8764 19.5761C15.2249 19.4019 15.6105 19.3151 16 19.3233C16.3895 19.3151 16.7751 19.4019 17.1236 19.5761C17.472 19.7504 17.7728 20.0068 18 20.3233C18.2272 20.6398 18.528 20.8962 18.8764 21.0704C19.2249 21.2447 19.6105 21.3314 20 21.3233C20.3895 21.3314 20.7751 21.2447 21.1236 21.0704C21.472 20.8962 21.7728 20.6398 22 20.3233"
            stroke="#98A2B3"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4 18.3232L3 13.3232H21L19 17.3232"
            stroke="#98A2B3"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5 13.3232V7.32324H13L17 13.3232"
            stroke="#98A2B3"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 7.32324V3.32324H6"
            stroke="#98A2B3"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ShipOwnerMenu;
